export default __webpack_public_path__ + "static/media/flv.af0db2b2.svg";